/* eslint-disable */
import { useEffect, useState, useContext } from 'react'
import PageHeader from '../../components/pages/header'
import Contact from '../../components/pages/contact'
import Video from '../../components/pages/video'
import Team from '../../components/pages/team'
import Recall from '../../components/pages/recall'
import text from './text.json'
import { PageContext } from '../../context/PageContextProvider'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'

const About = ({ className }) => {
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [data, setData] = useState([])
  useEffect(() => {
    (async () => {

    const { data } = await PagesAPI.getAbout()
    await setData(data)
    await setLoad(true)
  
    })();
  }, [])
  return load ? (
    <section className={className}>
      <PageHeader
        link={text.link}
        crumb={text.crumb[language]}
        title={data?.title?.[language] || data?.title?.TR || data?.title?.AZ || ''}
        text={
          data ? (
            language === 'AZ'
              ? data.description_az
              : language === 'TR'
              ? (data.description_tr || data.description_az)
              : language === 'ENG'
              ? data.description_eng
              : (data.description_ru || data.description_az)
          ) : ''
        }
      />
      <Video />
      <Team />
      <Contact />
      <Recall />
    </section>
  ) : (
    <Loading />
  )
}
export default About
